/**
 * 判断是否为中国
 * @param iso
 * @returns
 */
export function isCN(iso) {
  if (iso === 'CN') return true;
  return false;
}